<template>
    <form method="post" class="mr-2 search-form">
        <div class="form-group position-relative">
            <input :class="isShowSearchInput ? 'active form-control' : 'form-control'" type="text" name="search" placeholder="Search Q.A Here...">
            <el-button class="search-btn small-square" type="default" @click="isShowSearchInput=!isShowSearchInput">
                <el-icon>
                    <Search v-if="!isShowSearchInput" />
                    <Close v-else />
                </el-icon>
            </el-button>
        </div>
    </form>
</template>

<script>
import {Search, Close} from '@element-plus/icons-vue'

export default {
    name: 'SearchForm',
    components: {
        Search,
        Close
    },
    data() {
        return {
            isShowSearchInput: false
        }
    }
}
</script>
